import { useFocus } from '@/store/hooks/focus';
import { Marker } from 'leaflet';
import React from 'react';

export interface OpenPopupHandlerProps {
  markerRefs: Marker[];
}
const OpenPopupHandler: React.FunctionComponent<OpenPopupHandlerProps> = ({
  markerRefs,
}) => {
  const { focus } = useFocus();
  React.useEffect(() => {
    if (focus || focus !== undefined) {
      if (markerRefs[focus] && markerRefs[focus]) {
        markerRefs[focus].openPopup();
      }
    }
  }, [focus]);
  return null;
};
export default OpenPopupHandler;
